import { GetMeetingLinkQuery } from '@/core/graphql/types'
import { ProfessionalCard } from '@/_pages/appointment/meeting-link/ui/ProfessionalCard'

type StaffsProps = {
  meetingLink: GetMeetingLinkQuery['meetingLink']
  title: string
}

export function Staffs(props: StaffsProps) {
  const { meetingLink, title } = props

  return (
    <div className="space-y-4 p-4 sm:p-6">
      <h2 className="text-xl font-bold text-gray-900">{title}</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {meetingLink.staffs.map((staff) => (
          <ProfessionalCard
            key={staff._id}
            staff={staff}
            className={meetingLink.createdBy._id === staff._id ? 'border-primary/30 ring-1 ring-primary/10' : ''}
          />
        ))}
      </div>
    </div>
  )
}
